import React, { FC, RefObject, CSSProperties, MouseEvent, useState, useEffect, useCallback, useRef } from 'react';
import cn from 'classnames';
import { Icon } from '../Icon';
import { Button, ButtonThemes, IButtonProps } from '../Button';
require("./Favorite.css");
var styles = {
  "Root": "Favorite-module-Root_34E",
  "Icon": "Favorite-module-Icon_1B_",
  "IconWrapper": "Favorite-module-IconWrapper_D2f",
  "FlyHearts": "Favorite-module-FlyHearts_NNm",
  "n1FlyHeart": "Favorite-module-n1FlyHeart_uch",
  "n3FlyHeart": "Favorite-module-n3FlyHeart_1DJ",
  "n5FlyHeart": "Favorite-module-n5FlyHeart_2Iz",
  "hasEmphasis": "Favorite-module-hasEmphasis_221",
  "animate": "Favorite-module-animate_1Vm",
  "flyLeftTop": "Favorite-module-flyLeftTop_HyM",
  "flyRightTop": "Favorite-module-flyRightTop_1P-",
  "n2FlyHeart": "Favorite-module-n2FlyHeart_3jQ",
  "n4FlyHeart": "Favorite-module-n4FlyHeart_-xJ"
};
const svgHearts = [{
  d: 'M49.7 0C48.656 0 47.654 0.485559 47 1.24986C46.346 0.485559 45.344 0 44.3 0C42.449 0 41 1.44768 41 3.297C41 5.55995 43.04 7.40926 46.13 10.2117L47 11L47.87 10.2117C50.96 7.40926 53 5.55995 53 3.297C53 1.44768 51.551 0 49.7 0Z',
  opacity: 0.5
}, {
  d: 'M8.7 6C7.656 6 6.654 6.48556 6 7.24986C5.346 6.48556 4.344 6 3.3 6C1.449 6 0 7.44768 0 9.297C0 11.5599 2.04 13.4093 5.13 16.2117L6 17L6.87 16.2117C9.96 13.4093 12 11.5599 12 9.297C12 7.44768 10.551 6 8.7 6Z',
  opacity: 0.5
}, {
  d: 'M35.7 8C34.656 8 33.654 8.48556 33 9.24986C32.346 8.48556 31.344 8 30.3 8C28.449 8 27 9.44768 27 11.297C27 13.5599 29.04 15.4093 32.13 18.2117L33 19L33.87 18.2117C36.96 15.4093 39 13.5599 39 11.297C39 9.44768 37.551 8 35.7 8Z',
  opacity: 0.6
}, {
  d: 'M15.7 10C14.656 10 13.654 10.4856 13 11.2499C12.346 10.4856 11.344 10 10.3 10C8.449 10 7 11.4477 7 13.297C7 15.5599 9.04 17.4093 12.13 20.2117L13 21L13.87 20.2117C16.96 17.4093 19 15.5599 19 13.297C19 11.4477 17.551 10 15.7 10Z',
  opacity: 0.9
}, {
  d: 'M45.7 16C44.656 16 43.654 16.4856 43 17.2499C42.346 16.4856 41.344 16 40.3 16C38.449 16 37 17.4477 37 19.297C37 21.5599 39.04 23.4093 42.13 26.2117L43 27L43.87 26.2117C46.96 23.4093 49 21.5599 49 19.297C49 17.4477 47.551 16 45.7 16Z',
  opacity: 1
}];
export const Favorite = ({
  onClick,
  isChecked: isCheckedProp = false,
  hasEmphasis = false,
  hasAnimation = false,
  style = {},
  className,
  innerRef,
  controlRef
}) => {
  const isInitialMount = useRef(true);
  const [isChecked, setIsChecked] = useState(isCheckedProp);
  const [isAnimating, setIsAnimating] = useState(false);
  const handleAnimationStart = useCallback(isChecked => {
    if (isChecked && hasAnimation) {
      setIsAnimating(true);
    }
  }, [hasAnimation]);
  const handleAnimationEnd = useCallback(() => {
    setIsAnimating(false);
  }, []);
  useEffect(() => {
    if (isInitialMount.current) {
      isInitialMount.current = false;
    } else {
      setIsChecked(isCheckedProp);
      handleAnimationStart(isCheckedProp);
    }
  }, [isCheckedProp, handleAnimationStart]);
  const handleClick = useCallback(e => {
    e.preventDefault();
    setIsChecked(isChecked => {
      const updatedIsChecked = !isChecked;
      handleAnimationStart(updatedIsChecked);
      onClick(updatedIsChecked);
      return updatedIsChecked;
    });
  }, [onClick, handleAnimationStart]);
  return /*#__PURE__*/React.createElement("div", {
    onAnimationEnd: handleAnimationEnd,
    className: cn(styles.IconWrapper, {
      [styles.animate]: isAnimating,
      [styles.delayBgAnimation]: hasAnimation && hasEmphasis
    }, className)
  }, /*#__PURE__*/React.createElement(Button, {
    type: "button",
    controlRef: innerRef || controlRef,
    style: style,
    onClick: handleClick,
    "aria-pressed": isChecked,
    "aria-label": isChecked ? 'Товар добавлен в избранное' : 'Товар удален из избранного',
    theme: hasEmphasis ? ButtonThemes.light : ButtonThemes.transparent,
    className: styles.Root
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "heart",
    size: "m",
    className: styles.Icon
  })), isAnimating && /*#__PURE__*/React.createElement("svg", {
    width: "53",
    height: "27",
    viewBox: "0 0 53 27",
    fill: "none",
    focusable: false,
    "aria-hidden": true,
    className: styles.FlyHearts
  }, svgHearts.map((item, i) => /*#__PURE__*/React.createElement("path", {
    key: item.d,
    opacity: item.opacity,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: item.d,
    fill: "#FF0066",
    className: styles[`n${i + 1}FlyHeart`]
  }))));
};
if (process.env.NODE_ENV !== 'production') {
  Favorite.displayName = 'Favorite';
}